import { withStyles } from "@material-ui/styles";

// ----------------------------------------------------------------------

const GlobalStyles = withStyles((theme) => ({
  "@global": {
    "*": {
      margin: 0,
      padding: 0,
      boxSizing: "border-box",
    },
    html: {
      width: "100%",
      height: "100%",
      "-ms-text-size-adjust": "100%",
      "-webkit-overflow-scrolling": "touch",
    },
    body: {
      width: "100%",
      height: "100%",
    },
    "#root": {
      width: "100%",
      height: "100%",
    },
    input: {
      "&::-webkit-input-placeholder": { color: "#000000", opacity: 1 },
      "&::-moz-placeholder": { color: "#000000", opacity: 1 },
      "&:-ms-input-placeholder": { color: "#000000", opacity: 1 },
      "&[type=number]": {
        MozAppearance: "textfield",
        "&::-webkit-outer-spin-button": { margin: 0, WebkitAppearance: "none" },
        "&::-webkit-inner-spin-button": { margin: 0, WebkitAppearance: "none" },
      },
      "&:focus:not(:focus-visible)": {
        outline: "none",
      },
      "&:focus-visible": {
        outline: "2px solid #4C7DF0",
        outlineOffset: "2px",
      },
    },
    select: {
      color: "#000000",
      caretColor: "#000000",
      "&::placeholder": { color: "#000000", opacity: 1 },
      "&:focus:not(:focus-visible)": {
        outline: "none",
      },
      "&:focus-visible": {
        outline: "2px solid #4C7DF0",
        outlineOffset: "2px",
      },
    },
    textarea: {
      color: "#000000",
      caretColor: "#000000",
      "&::-webkit-input-placeholder": { color: "#000000", opacity: 1 },
      "&::-moz-placeholder": { opacity: 1, color: "#000000" },
      "&:-ms-input-placeholder": { color: "#000000", opacity: 1 },
      "&::placeholder": { color: "#000000", opacity: 1 },
      "&:focus:not(:focus-visible)": {
        outline: "none",
      },
      "&:focus-visible": {
        outline: "2px solid #4C7DF0",
        outlineOffset: "2px",
      },
    },
    // eslint-disable-next-line id-length
    a: {
      color: theme.palette.primary.main,
      "&:focus:not(:focus-visible)": {
        outline: "none",
      },
      "&:focus-visible": {
        outline: "2px solid #4C7DF0",
        outlineOffset: "2px",
      },
    },
    button: {
      "&:focus:not(:focus-visible)": {
        outline: "none",
      },
      "&:focus-visible": {
        outline: "2px solid #4C7DF0",
        outlineOffset: "2px",
      },
    },
    "[role='button']": {
      "&:focus:not(:focus-visible)": {
        outline: "none",
      },
      "&:focus-visible": {
        outline: "2px solid #4C7DF0",
        outlineOffset: "2px",
      },
    },
    "[tabindex]:not([tabindex='-1'])": {
      "&:focus:not(:focus-visible)": {
        outline: "none",
      },
      "&:focus-visible": {
        outline: "2px solid #4C7DF0",
        outlineOffset: "2px",
      },
    },
    img: { display: "block", maxWidth: "100%" },
  },
}))(() => null);

export default GlobalStyles;
